var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.64258,
    y: 2.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white",
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0884 18.2669L14.1422 15.3206L11.1959 18.2669C10.8718 18.591 10.3415 18.591 10.0174 18.2669C9.69327 17.9428 9.69327 17.4125 10.0174 17.0884L12.9636 14.1421L10.0174 11.1958C9.69327 10.8718 9.69327 10.3414 10.0174 10.0173C10.3415 9.69325 10.8718 9.69325 11.1959 10.0173L14.1422 12.9636L17.0884 10.0173C17.4125 9.69325 17.9429 9.69325 18.2669 10.0173C18.591 10.3414 18.591 10.8718 18.2669 11.1958L15.3207 14.1421L18.2669 17.0884C18.591 17.4125 18.591 17.9428 18.2669 18.2669C17.9428 18.591 17.4125 18.591 17.0884 18.2669Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.f30b995145bd592cc334dfa3f9ea2743.svg";
export { ForwardRef as ReactComponent };